import {Filters } from 'react-data-grid-addons';
import DollarFormatter, {EditableDollarFormatter, GreyDollarFormatter, PreviewDollarFormatter} from '../DollarFormatter';


export default {
  accessorialDataColumns: [
    {
      key: "accessorial",
      name: "Accessorial",
      // formatter: TextFormatter,
      resizable: true,
      filterable: true,
      sortable: true
    },
    {
      key: "rate",
      name: "Rate",
      // formatter: TextFormatter,
      resizable: true,
      filterable: true,
      sortable: true,
      filterRenderer: Filters.NumericFilter,
      formatter: DollarFormatter
    },    
    {
      key: "baseRate",
      name: "Base Rate",
      resizable: true,
      filterable: true,
      sortable: true,
      filterRenderer: Filters.NumericFilter,
      formatter: GreyDollarFormatter
    }
  ],  
  accessorialEditDataColumns:[
    {
      key: "accessorial",
      name: "Accessorial",
      // formatter: TextFormatter,
      resizable: true,
      filterable: true,
      sortable: true
    },
    {
      key: "rate",
      name: "Rate",
      // formatter: TextFormatter,
      resizable: true,
      filterable: true,
      sortable: true,
      filterRenderer: Filters.NumericFilter,
      formatter: DollarFormatter
    }, {
      key: "newRate",
      name: "New Rate",
      resizable: true,
      filterable: true,
      editable: true,
      sortable: true,
      filterRenderer: Filters.NumericFilter,
      formatter: EditableDollarFormatter
    }
  ],
  accessorialPreviewDataColumns:[
    {
      key: "accessorial",
      name: "Accessorial",
      // formatter: TextFormatter,
      resizable: true,
      filterable: true,
      sortable: true
    },
    {
      key: "rate",
      name: "Rate",
      // formatter: TextFormatter,
      resizable: true,
      filterable: true,
      sortable: true,
      filterRenderer: Filters.NumericFilter,
      formatter: DollarFormatter
    }, {
      key: "newRate",
      name: "New Rate",
      resizable: true,
      filterable: true,
      editable: false,
      sortable: true,
      filterRenderer: Filters.NumericFilter,
      formatter: PreviewDollarFormatter
    }
  ]
};


// WEBPACK FOOTER //
// ./src/components/AccessorialsAndFees/table_columns.js